<template>
  <div class="app-router">
    <h2 class="font-weight-bold">Rekening Bank</h2>
    <div class="text-subtitle-2 pb-4">Berikut ini adalah pengaturan informasi rekening bank yang kamu gunakan.</div>

    <v-row>
      <v-col cols="12" sm="9">
        <v-card flat outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold">
            Detail Rekening Seller
          </v-card-title>
          <hr>
          <v-card-text>
            <v-form ref="formRekening" role="form">
              <v-row class="align-center">
                <v-col cols="12" sm="5" class="py-xs-0">
                  <div class="d-block text-subtitle-2 font-weight-bold black--text">
                    Nama Rekening 
                      <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon> <br>
                        <span class="text-caption">(harus sama dengan rekening bank)</span>
                  </div> 
                </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    v-model="sellerBank.bank_account_name"
                    hide-details="auto"
                    dense
                    outlined
                    type="text"
                    class="d-flex align-center"
                    :rules="accountNameRules"
                    placeholder="masukkan nama rekening"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col cols="12" sm="5" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Bank<v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon> </div></v-col>
                <v-col cols="12" sm="7">
                  <v-autocomplete
                    v-model="sellerBank.bank_name"
                    :items="listBank"
                    hide-details="auto"
                    item-value="bank_name"
                    item-text="bank_name"
                    outlined
                    dense
                    :rules="bankCodeRules"
                    placeholder="Pilih Bank"
                  >
                    <template v-slot:selection="data">
                      <div class="d-flex flex-row align-center justify-left">
                        <!-- <v-img width="60" max-width="60" class="mr-0" :src="'/assets/bank/' + data.item.bank_name.replace(' ', '-') + '.svg'" alt="/assets/bank/default.svg"></v-img> -->
                        <div class="d-flex flex-column">
                          <strong>{{ data.item.bank_name }}</strong>
                        </div>
                      </div>
                    </template>

                    <template v-slot:item="data">
                      <div class="d-flex flex-row align-center justify-left">
                        <!-- <v-img width="60" max-width="60" class="mr-0" :src="'/assets/bank/' + data.item.bank_name.replace(' ', '-') + '.svg'" alt="/assets/bank/default.svg"></v-img> -->
                        <div class="d-flex flex-column">
                          <strong>{{ data.item.bank_name }}</strong>
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col cols="12" sm="5" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Nomor Rekening<v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon> </div></v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    v-model="sellerBank.bank_account_number"
                    hide-details="auto"
                    dense
                    outlined
                    type="text"
                    class="d-flex align-center"
                    :rules="accountNumberRules"
                    @keypress="onlyNumber"
                    placeholder="masukkan nomor rekening"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col cols="12" sm="5" class="py-xs-0"><div class="d-block text-subtitle-2 font-weight-bold black--text">Cabang Bank<v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon> </div></v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    v-model="sellerBank.bank_branch"
                    hide-details="auto"
                    dense
                    outlined
                    type="text"
                    class="d-flex align-center"
                    :rules="bankBranchRules"
                    placeholder="masukkan cabang bank"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <hr class="mt-5">
              <v-row>
                <v-col cols="12" sm="5" class="py-xs-0"></v-col>
                <v-col cols="12" sm="7" class="text-right">
                  <v-btn
                    color="green"
                    :loading="loadingProcess"
                    class="my-2 px-5 text-capitalize white--text btn-block-xs"
                    @click="updateRekening()"
                  >
                    Simpan
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'update-rekening',
  data() {
    return {
      loadingProcess: false,
      loading: false,
      sellerBank: {
        bank_account_name: '',
        bank_account_number: '',
        bank_name: '',
        bank_branch: ''
      },
      bankCodeRules: [
        v => !!v || 'Bank tidak boleh kosong'
      ],
      accountNumberRules: [
        v => !!v || 'Nomor rekening tidak boleh kosong',
        v => !isNaN(parseInt(v)) || 'Jumlah belanja mohon diisi dengan angka',
      ],
      accountNameRules: [
        v => !!v || 'Nama rekening tidak boleh kosong'
      ],
      bankBranchRules: [
        v => !!v || 'Cabang Bank tidak boleh kosong'
      ],
      bankList: [
        {
          bank_code: 'bca',
          bank_logo: '/assets/bank/bca.svg',
          bank_name: 'BCA'
        }
      ],
    }
  },

  computed: {
    ...mapState('options', ['courier', 'listBank']),
    ...mapState('storeSeller', ['detailStore', 'response', 'responseError'])
  },

  methods: {
    ...mapActions('options', ['getCourier', 'getBankList']),
    ...mapActions('storeSeller', ['getStoreDetail', 'updateStoreBank']),

    async updateRekening() {
      if (this.$refs.formRekening.validate()) {
        this.loadingProcess = await true
        this.updateStoreBank(this.sellerBank)
          .then(async() => {
            await this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
            await this.getStoreDetail()
            if (this.detailStore) {
              this.sellerBank = await {
                bank_account_name: this.detailStore.store_bank_account_name,
                bank_account_number: this.detailStore.store_bank_account_number,
                bank_name: this.detailStore.store_bank_name,
                bank_branch: this.detailStore.store_bank_branch
              }
            }
            this.loadingProcess = false
          })
          .catch(() => {
            this.loadingProcess = false
          })
      } else {
        this.loadingProcess = false
      }
    }
  },

  async created() {
    this.$store.dispatch('setPageTitle', `Rekening Bank`);
    await this.getStoreDetail()
    await this.getBankList()
    if (this.detailStore) {
      this.sellerBank = await {
        bank_account_name: (this.detailStore.store_bank_account_name || this.detailStore.store_bank_account_name !== '') ? this.detailStore.store_bank_account_name : null,
        bank_account_number: (this.detailStore.store_bank_account_number || this.detailStore.store_bank_account_number !== '') ? this.detailStore.store_bank_account_number : null,
        bank_name: (this.detailStore.store_bank_name || this.detailStore.store_bank_name !== '') ? this.detailStore.store_bank_name : null,
        bank_branch: (this.detailStore.store_bank_branch || this.detailStore.store_bank_branch !== '') ? this.detailStore.store_bank_branch : null
      }
    }
  },
}
</script>